// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.auth-container {
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  background-attachment: fixed;
  padding: 2rem;
  position: relative;
  overflow: hidden;
}

.auth-container::before {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: radial-gradient(
      circle at 20% 50%,
      rgba(255, 255, 255, 0.1) 0%,
      transparent 50%
    ),
    radial-gradient(
      circle at 80% 20%,
      rgba(255, 255, 255, 0.1) 0%,
      transparent 50%
    ),
    radial-gradient(
      circle at 40% 80%,
      rgba(255, 255, 255, 0.1) 0%,
      transparent 50%
    );
  animation: float 20s ease-in-out infinite;
}

@keyframes float {
  0%,
  100% {
    transform: translateY(0px) rotate(0deg);
  }
  33% {
    transform: translateY(-10px) rotate(1deg);
  }
  66% {
    transform: translateY(5px) rotate(-1deg);
  }
}

.auth-card {
  background: rgba(255, 255, 255, 0.95);
  backdrop-filter: blur(20px);
  border: 1px solid rgba(255, 255, 255, 0.2);
  border-radius: 24px;
  box-shadow: 0 25px 50px rgba(0, 0, 0, 0.15), 0 8px 16px rgba(0, 0, 0, 0.1),
    inset 0 1px 0 rgba(255, 255, 255, 0.8);
  padding: 3rem;
  width: 100%;
  max-width: 450px;
  position: relative;
  z-index: 1;
  transform: translateY(0);
  transition: all 0.3s ease;
}

.auth-card:hover {
  transform: translateY(-5px);
  box-shadow: 0 35px 70px rgba(0, 0, 0, 0.2), 0 15px 30px rgba(0, 0, 0, 0.15),
    inset 0 1px 0 rgba(255, 255, 255, 0.8);
}

.auth-header {
  text-align: center;
  margin-bottom: 2rem;
}

.auth-logo {
  display: flex;
  justify-content: center;
  margin-bottom: 1.5rem;
  animation: logoFloat 3s ease-in-out infinite;
}

.logo-image {
  height: 64px;
  width: auto;
  max-width: 200px;
  object-fit: contain;
  filter: drop-shadow(0 4px 8px rgba(0, 0, 0, 0.1));
}

@keyframes logoFloat {
  0%,
  100% {
    transform: translateY(0px) rotate(0deg);
  }
  50% {
    transform: translateY(-5px) rotate(5deg);
  }
}

.auth-card h1 {
  background: linear-gradient(135deg, #667eea, #764ba2);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
  margin-bottom: 0.5rem;
  text-align: center;
  font-size: 2.2rem;
  font-weight: 700;
  letter-spacing: -0.5px;
}

.auth-subtitle {
  color: #666;
  text-align: center;
  margin-bottom: 2.5rem;
  font-size: 1.1rem;
  font-weight: 400;
  opacity: 0.8;
}

.test-accounts {
  background: #f8f9fa;
  border: 1px solid #dee2e6;
  border-radius: 8px;
  padding: 1rem;
  margin-bottom: 1.5rem;
}

.test-accounts h4 {
  color: #495057;
  margin: 0 0 0.75rem 0;
  font-size: 0.9rem;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

.account-info {
  color: #6c757d;
  font-size: 0.85rem;
  margin-bottom: 0.5rem;
  padding: 0.25rem 0;
}

.account-info:last-child {
  margin-bottom: 0;
}

.account-info strong {
  color: #495057;
  display: inline-block;
  min-width: 100px;
}

.error-message {
  background: linear-gradient(135deg, #ff6b6b, #ee5a24);
  color: white;
  padding: 1rem 1.25rem;
  border-radius: 12px;
  margin-bottom: 1.5rem;
  text-align: center;
  font-weight: 500;
  box-shadow: 0 4px 15px rgba(255, 107, 107, 0.3);
  border-left: 4px solid rgba(255, 255, 255, 0.3);
}

.auth-form {
  margin-bottom: 1.5rem;
}

.form-group {
  margin-bottom: 1.75rem;
}

.form-group label {
  display: block;
  color: #4a5568;
  font-weight: 600;
  margin-bottom: 0.75rem;
  font-size: 0.95rem;
  letter-spacing: 0.3px;
}

.form-group input {
  width: 100%;
  padding: 1.1rem 1.25rem;
  border: 2px solid #e1e5e9;
  border-radius: 12px;
  font-size: 1rem;
  line-height: 1.5;
  background: rgba(255, 255, 255, 0.8);
  transition: all 0.3s ease;
  backdrop-filter: blur(10px);
  min-height: 48px;
  box-sizing: border-box;
}

.form-group input::placeholder {
  color: #a0aec0;
  font-weight: 400;
}

.form-group input:focus {
  outline: none;
  border-color: #667eea;
  background: rgba(255, 255, 255, 1);
  box-shadow: 0 0 0 4px rgba(102, 126, 234, 0.15),
    0 4px 12px rgba(102, 126, 234, 0.1);
  transform: translateY(-2px);
}

.form-group input:disabled {
  background: #f5f5f5;
  cursor: not-allowed;
}

.server-info {
  display: block;
  margin-top: 0.75rem;
  color: #10b981;
  font-size: 0.85rem;
  font-weight: 600;
  background: rgba(16, 185, 129, 0.1);
  padding: 0.5rem 0.75rem;
  border-radius: 8px;
  border-left: 3px solid #10b981;
}

.btn-block {
  width: 100%;
  padding: 1rem 2rem;
  font-weight: 600;
  display: flex;
  justify-content: center;
  align-items: center;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  color: white;
  border: none;
  border-radius: 12px;
  cursor: pointer;
  transition: all 0.3s ease;
  box-shadow: 0 4px 15px rgba(102, 126, 234, 0.3);
  letter-spacing: 0.5px;
  text-transform: uppercase;
  font-size: 0.95rem;
}

.btn-block:hover:not(:disabled) {
  transform: translateY(-2px);
  box-shadow: 0 8px 25px rgba(102, 126, 234, 0.4);
  background: linear-gradient(135deg, #5a6fd8 0%, #6a4190 100%);
}

.btn-block:active:not(:disabled) {
  transform: translateY(0px);
  box-shadow: 0 4px 15px rgba(102, 126, 234, 0.3);
}

.btn-block:disabled {
  background: linear-gradient(135deg, #9ca3af 0%, #9ca3af 100%);
  cursor: not-allowed;
  opacity: 0.7;
  transform: none;
  box-shadow: 0 2px 8px rgba(156, 163, 175, 0.2);
}

/* 아이디 저장 체크박스 스타일 */
.remember-me-group {
  margin-bottom: 1.5rem;
}

.remember-me-label {
  display: flex;
  align-items: center;
  cursor: pointer;
  font-size: 0.95rem;
  color: #4a5568;
  font-weight: 500;
  margin-bottom: 0;
}

.remember-me-checkbox {
  display: none;
}

.checkmark {
  width: 20px;
  height: 20px;
  border: 2px solid #e1e5e9;
  border-radius: 6px;
  margin-right: 0.75rem;
  position: relative;
  transition: all 0.3s ease;
  background: rgba(255, 255, 255, 0.8);
  backdrop-filter: blur(10px);
}

.remember-me-checkbox:checked + .checkmark {
  background: linear-gradient(135deg, #667eea, #764ba2);
  border-color: #667eea;
  box-shadow: 0 2px 8px rgba(102, 126, 234, 0.3);
}

.remember-me-checkbox:checked + .checkmark::after {
  content: "";
  position: absolute;
  left: 6px;
  top: 2px;
  width: 6px;
  height: 10px;
  border: solid white;
  border-width: 0 2px 2px 0;
  transform: rotate(45deg);
}

.remember-me-label:hover .checkmark {
  border-color: #667eea;
  box-shadow: 0 0 0 2px rgba(102, 126, 234, 0.1);
}

.remember-me-checkbox:disabled + .checkmark {
  opacity: 0.6;
  cursor: not-allowed;
}

.auth-footer {
  text-align: center;
  color: #666;
  padding-top: 1rem;
  border-top: 1px solid #eee;
}

.auth-footer a {
  color: #667eea;
  text-decoration: none;
  font-weight: 500;
}

.auth-footer a:hover {
  text-decoration: underline;
}

.btn-secondary {
  background: #6c757d;
  color: white;
  border: none;
  padding: 0.75rem 1.5rem;
  border-radius: 6px;
  font-size: 1rem;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s;
}

.btn-secondary:hover {
  background: #5a6268;
  transform: translateY(-1px);
}

.demo-info {
  margin-top: 2rem;
  padding: 1rem;
  background: #f8f9fa;
  border-radius: 6px;
  border-left: 4px solid #667eea;
}

.demo-title {
  font-weight: bold;
  color: #333;
  margin-bottom: 0.5rem;
}

.demo-info p {
  margin: 0.25rem 0;
  color: #666;
  font-size: 0.9rem;
}

/* 반응형 디자인 */
@media (max-width: 768px) {
  .auth-container {
    padding: 1rem;
  }

  .auth-card {
    padding: 2rem 1.5rem;
    margin: 1rem;
  }

  .auth-card h1 {
    font-size: 1.8rem;
  }

  .auth-subtitle {
    font-size: 1rem;
  }

  .form-group input {
    padding: 1rem 1rem;
    min-height: 44px;
  }

  .btn-block {
    padding: 0.875rem 1.5rem;
  }

  .logo-image {
    height: 56px;
  }
}

@media (max-width: 480px) {
  .auth-card {
    padding: 1.5rem 1rem;
  }

  .auth-card h1 {
    font-size: 1.6rem;
  }

  .logo-image {
    height: 48px;
  }
}

/* 터치 디바이스를 위한 추가 스타일 */
@media (hover: none) {
  .auth-card:hover {
    transform: none;
  }

  .btn-block:hover:not(:disabled) {
    transform: none;
  }

  .form-group input:focus {
    transform: none;
  }
}

/* 다크모드 스타일 */
.dark-theme .auth-container,
[data-theme="dark"] .auth-container {
  background: linear-gradient(135deg, #2d3748 0%, #1a202c 100%);
}

.dark-theme .auth-card,
[data-theme="dark"] .auth-card {
  background: rgba(26, 32, 44, 0.95);
  border: 1px solid rgba(74, 85, 104, 0.3);
  box-shadow: 0 25px 50px rgba(0, 0, 0, 0.5), 0 8px 16px rgba(0, 0, 0, 0.3),
    inset 0 1px 0 rgba(74, 85, 104, 0.3);
}

.dark-theme .auth-card:hover,
[data-theme="dark"] .auth-card:hover {
  box-shadow: 0 35px 70px rgba(0, 0, 0, 0.6), 0 15px 30px rgba(0, 0, 0, 0.4),
    inset 0 1px 0 rgba(74, 85, 104, 0.3);
}

.dark-theme .auth-card h1,
[data-theme="dark"] .auth-card h1 {
  background: linear-gradient(135deg, #9f7aea, #805ad5);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
}

.dark-theme .auth-subtitle,
[data-theme="dark"] .auth-subtitle {
  color: #a0aec0;
}

.dark-theme .form-group label,
[data-theme="dark"] .form-group label {
  color: #e2e8f0;
}

.dark-theme .auth-container .form-group input[type="text"],
.dark-theme .auth-container .form-group input[type="password"],
[data-theme="dark"] .auth-container .form-group input[type="text"],
[data-theme="dark"] .auth-container .form-group input[type="password"] {
  background: rgba(45, 55, 72, 0.8) !important;
  border: 2px solid #4a5568 !important;
  color: #e2e8f0 !important;
}

.dark-theme .form-group input::placeholder,
[data-theme="dark"] .form-group input::placeholder {
  color: #718096;
}

.dark-theme .auth-container .form-group input:focus,
[data-theme="dark"] .auth-container .form-group input:focus {
  border-color: #9f7aea !important;
  background: rgba(45, 55, 72, 1) !important;
  box-shadow: 0 0 0 4px rgba(159, 122, 234, 0.15),
    0 4px 12px rgba(159, 122, 234, 0.1) !important;
}

.dark-theme .form-group input:disabled,
[data-theme="dark"] .form-group input:disabled {
  background: #2d3748;
  color: #718096;
}

.dark-theme .server-info,
[data-theme="dark"] .server-info {
  color: #48bb78;
  background: rgba(72, 187, 120, 0.1);
  border-left-color: #48bb78;
}

.dark-theme .btn-block,
[data-theme="dark"] .btn-block {
  background: linear-gradient(135deg, #9f7aea 0%, #805ad5 100%);
  box-shadow: 0 4px 15px rgba(159, 122, 234, 0.3);
}

.dark-theme .btn-block:hover:not(:disabled),
[data-theme="dark"] .btn-block:hover:not(:disabled) {
  background: linear-gradient(135deg, #805ad5 0%, #6b46c1 100%);
  box-shadow: 0 8px 25px rgba(159, 122, 234, 0.4);
}

.dark-theme .btn-block:disabled,
[data-theme="dark"] .btn-block:disabled {
  background: linear-gradient(135deg, #4a5568 0%, #4a5568 100%);
  box-shadow: 0 2px 8px rgba(74, 85, 104, 0.2);
}

.dark-theme .error-message,
[data-theme="dark"] .error-message {
  background: linear-gradient(135deg, #fc8181, #f56565);
}

.dark-theme .remember-me-label,
[data-theme="dark"] .remember-me-label {
  color: #e2e8f0;
}

.dark-theme .checkmark,
[data-theme="dark"] .checkmark {
  background: rgba(45, 55, 72, 0.8);
  border-color: #4a5568;
}

.dark-theme .remember-me-checkbox:checked + .checkmark,
[data-theme="dark"] .remember-me-checkbox:checked + .checkmark {
  background: linear-gradient(135deg, #9f7aea, #805ad5);
  border-color: #9f7aea;
  box-shadow: 0 2px 8px rgba(159, 122, 234, 0.3);
}

.dark-theme .remember-me-label:hover .checkmark,
[data-theme="dark"] .remember-me-label:hover .checkmark {
  border-color: #9f7aea;
  box-shadow: 0 0 0 2px rgba(159, 122, 234, 0.1);
}

.dark-theme .logo-image,
[data-theme="dark"] .logo-image {
  filter: drop-shadow(0 4px 8px rgba(0, 0, 0, 0.3)) brightness(1.2);
}
`, "",{"version":3,"sources":["webpack://./src/components/Login.css"],"names":[],"mappings":"AAAA;EACE,iBAAiB;EACjB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,6DAA6D;EAC7D,4BAA4B;EAC5B,aAAa;EACb,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT;;;;;;;;;;;;;;KAcG;EACH,yCAAyC;AAC3C;;AAEA;EACE;;IAEE,uCAAuC;EACzC;EACA;IACE,yCAAyC;EAC3C;EACA;IACE,wCAAwC;EAC1C;AACF;;AAEA;EACE,qCAAqC;EACrC,2BAA2B;EAC3B,0CAA0C;EAC1C,mBAAmB;EACnB;0CACwC;EACxC,aAAa;EACb,WAAW;EACX,gBAAgB;EAChB,kBAAkB;EAClB,UAAU;EACV,wBAAwB;EACxB,yBAAyB;AAC3B;;AAEA;EACE,2BAA2B;EAC3B;0CACwC;AAC1C;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,qBAAqB;EACrB,4CAA4C;AAC9C;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,gBAAgB;EAChB,mBAAmB;EACnB,iDAAiD;AACnD;;AAEA;EACE;;IAEE,uCAAuC;EACzC;EACA;IACE,wCAAwC;EAC1C;AACF;;AAEA;EACE,qDAAqD;EACrD,6BAA6B;EAC7B,oCAAoC;EACpC,qBAAqB;EACrB,qBAAqB;EACrB,kBAAkB;EAClB,iBAAiB;EACjB,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,qBAAqB;EACrB,iBAAiB;EACjB,gBAAgB;EAChB,YAAY;AACd;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,aAAa;EACb,qBAAqB;AACvB;;AAEA;EACE,cAAc;EACd,qBAAqB;EACrB,iBAAiB;EACjB,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,qBAAqB;EACrB,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,qBAAqB;EACrB,gBAAgB;AAClB;;AAEA;EACE,qDAAqD;EACrD,YAAY;EACZ,qBAAqB;EACrB,mBAAmB;EACnB,qBAAqB;EACrB,kBAAkB;EAClB,gBAAgB;EAChB,+CAA+C;EAC/C,+CAA+C;AACjD;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,cAAc;EACd,cAAc;EACd,gBAAgB;EAChB,sBAAsB;EACtB,kBAAkB;EAClB,qBAAqB;AACvB;;AAEA;EACE,WAAW;EACX,uBAAuB;EACvB,yBAAyB;EACzB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,oCAAoC;EACpC,yBAAyB;EACzB,2BAA2B;EAC3B,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,kCAAkC;EAClC;uCACqC;EACrC,2BAA2B;AAC7B;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,mBAAmB;EACnB,cAAc;EACd,kBAAkB;EAClB,gBAAgB;EAChB,mCAAmC;EACnC,uBAAuB;EACvB,kBAAkB;EAClB,8BAA8B;AAChC;;AAEA;EACE,WAAW;EACX,kBAAkB;EAElB,gBAAgB;EAChB,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,6DAA6D;EAC7D,YAAY;EACZ,YAAY;EACZ,mBAAmB;EACnB,eAAe;EACf,yBAAyB;EACzB,+CAA+C;EAC/C,qBAAqB;EACrB,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,2BAA2B;EAC3B,+CAA+C;EAC/C,6DAA6D;AAC/D;;AAEA;EACE,0BAA0B;EAC1B,+CAA+C;AACjD;;AAEA;EACE,6DAA6D;EAC7D,mBAAmB;EACnB,YAAY;EACZ,eAAe;EACf,8CAA8C;AAChD;;AAEA,oBAAoB;AACpB;EACE,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,kBAAkB;EAClB,cAAc;EACd,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,kBAAkB;EAClB,qBAAqB;EACrB,kBAAkB;EAClB,yBAAyB;EACzB,oCAAoC;EACpC,2BAA2B;AAC7B;;AAEA;EACE,qDAAqD;EACrD,qBAAqB;EACrB,8CAA8C;AAChD;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,SAAS;EACT,QAAQ;EACR,UAAU;EACV,YAAY;EACZ,mBAAmB;EACnB,yBAAyB;EACzB,wBAAwB;AAC1B;;AAEA;EACE,qBAAqB;EACrB,8CAA8C;AAChD;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,iBAAiB;EACjB,0BAA0B;AAC5B;;AAEA;EACE,cAAc;EACd,qBAAqB;EACrB,gBAAgB;AAClB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,YAAY;EACZ,uBAAuB;EACvB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,oBAAoB;AACtB;;AAEA;EACE,mBAAmB;EACnB,2BAA2B;AAC7B;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,kBAAkB;EAClB,8BAA8B;AAChC;;AAEA;EACE,iBAAiB;EACjB,WAAW;EACX,qBAAqB;AACvB;;AAEA;EACE,iBAAiB;EACjB,WAAW;EACX,iBAAiB;AACnB;;AAEA,YAAY;AACZ;EACE;IACE,aAAa;EACf;;EAEA;IACE,oBAAoB;IACpB,YAAY;EACd;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,kBAAkB;IAClB,gBAAgB;EAClB;;EAEA;IACE,wBAAwB;EAC1B;;EAEA;IACE,YAAY;EACd;AACF;;AAEA;EACE;IACE,oBAAoB;EACtB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,YAAY;EACd;AACF;;AAEA,uBAAuB;AACvB;EACE;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;AACF;;AAEA,aAAa;AACb;;EAEE,6DAA6D;AAC/D;;AAEA;;EAEE,kCAAkC;EAClC,wCAAwC;EACxC;wCACsC;AACxC;;AAEA;;EAEE;wCACsC;AACxC;;AAEA;;EAEE,qDAAqD;EACrD,6BAA6B;EAC7B,oCAAoC;EACpC,qBAAqB;AACvB;;AAEA;;EAEE,cAAc;AAChB;;AAEA;;EAEE,cAAc;AAChB;;AAEA;;;;EAIE,4CAA4C;EAC5C,oCAAoC;EACpC,yBAAyB;AAC3B;;AAEA;;EAEE,cAAc;AAChB;;AAEA;;EAEE,gCAAgC;EAChC,0CAA0C;EAC1C;kDACgD;AAClD;;AAEA;;EAEE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;;EAEE,cAAc;EACd,mCAAmC;EACnC,0BAA0B;AAC5B;;AAEA;;EAEE,6DAA6D;EAC7D,+CAA+C;AACjD;;AAEA;;EAEE,6DAA6D;EAC7D,+CAA+C;AACjD;;AAEA;;EAEE,6DAA6D;EAC7D,4CAA4C;AAC9C;;AAEA;;EAEE,qDAAqD;AACvD;;AAEA;;EAEE,cAAc;AAChB;;AAEA;;EAEE,iCAAiC;EACjC,qBAAqB;AACvB;;AAEA;;EAEE,qDAAqD;EACrD,qBAAqB;EACrB,8CAA8C;AAChD;;AAEA;;EAEE,qBAAqB;EACrB,8CAA8C;AAChD;;AAEA;;EAEE,iEAAiE;AACnE","sourcesContent":[".auth-container {\n  min-height: 100vh;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);\n  background-attachment: fixed;\n  padding: 2rem;\n  position: relative;\n  overflow: hidden;\n}\n\n.auth-container::before {\n  content: \"\";\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background: radial-gradient(\n      circle at 20% 50%,\n      rgba(255, 255, 255, 0.1) 0%,\n      transparent 50%\n    ),\n    radial-gradient(\n      circle at 80% 20%,\n      rgba(255, 255, 255, 0.1) 0%,\n      transparent 50%\n    ),\n    radial-gradient(\n      circle at 40% 80%,\n      rgba(255, 255, 255, 0.1) 0%,\n      transparent 50%\n    );\n  animation: float 20s ease-in-out infinite;\n}\n\n@keyframes float {\n  0%,\n  100% {\n    transform: translateY(0px) rotate(0deg);\n  }\n  33% {\n    transform: translateY(-10px) rotate(1deg);\n  }\n  66% {\n    transform: translateY(5px) rotate(-1deg);\n  }\n}\n\n.auth-card {\n  background: rgba(255, 255, 255, 0.95);\n  backdrop-filter: blur(20px);\n  border: 1px solid rgba(255, 255, 255, 0.2);\n  border-radius: 24px;\n  box-shadow: 0 25px 50px rgba(0, 0, 0, 0.15), 0 8px 16px rgba(0, 0, 0, 0.1),\n    inset 0 1px 0 rgba(255, 255, 255, 0.8);\n  padding: 3rem;\n  width: 100%;\n  max-width: 450px;\n  position: relative;\n  z-index: 1;\n  transform: translateY(0);\n  transition: all 0.3s ease;\n}\n\n.auth-card:hover {\n  transform: translateY(-5px);\n  box-shadow: 0 35px 70px rgba(0, 0, 0, 0.2), 0 15px 30px rgba(0, 0, 0, 0.15),\n    inset 0 1px 0 rgba(255, 255, 255, 0.8);\n}\n\n.auth-header {\n  text-align: center;\n  margin-bottom: 2rem;\n}\n\n.auth-logo {\n  display: flex;\n  justify-content: center;\n  margin-bottom: 1.5rem;\n  animation: logoFloat 3s ease-in-out infinite;\n}\n\n.logo-image {\n  height: 64px;\n  width: auto;\n  max-width: 200px;\n  object-fit: contain;\n  filter: drop-shadow(0 4px 8px rgba(0, 0, 0, 0.1));\n}\n\n@keyframes logoFloat {\n  0%,\n  100% {\n    transform: translateY(0px) rotate(0deg);\n  }\n  50% {\n    transform: translateY(-5px) rotate(5deg);\n  }\n}\n\n.auth-card h1 {\n  background: linear-gradient(135deg, #667eea, #764ba2);\n  -webkit-background-clip: text;\n  -webkit-text-fill-color: transparent;\n  background-clip: text;\n  margin-bottom: 0.5rem;\n  text-align: center;\n  font-size: 2.2rem;\n  font-weight: 700;\n  letter-spacing: -0.5px;\n}\n\n.auth-subtitle {\n  color: #666;\n  text-align: center;\n  margin-bottom: 2.5rem;\n  font-size: 1.1rem;\n  font-weight: 400;\n  opacity: 0.8;\n}\n\n.test-accounts {\n  background: #f8f9fa;\n  border: 1px solid #dee2e6;\n  border-radius: 8px;\n  padding: 1rem;\n  margin-bottom: 1.5rem;\n}\n\n.test-accounts h4 {\n  color: #495057;\n  margin: 0 0 0.75rem 0;\n  font-size: 0.9rem;\n  text-transform: uppercase;\n  letter-spacing: 0.5px;\n}\n\n.account-info {\n  color: #6c757d;\n  font-size: 0.85rem;\n  margin-bottom: 0.5rem;\n  padding: 0.25rem 0;\n}\n\n.account-info:last-child {\n  margin-bottom: 0;\n}\n\n.account-info strong {\n  color: #495057;\n  display: inline-block;\n  min-width: 100px;\n}\n\n.error-message {\n  background: linear-gradient(135deg, #ff6b6b, #ee5a24);\n  color: white;\n  padding: 1rem 1.25rem;\n  border-radius: 12px;\n  margin-bottom: 1.5rem;\n  text-align: center;\n  font-weight: 500;\n  box-shadow: 0 4px 15px rgba(255, 107, 107, 0.3);\n  border-left: 4px solid rgba(255, 255, 255, 0.3);\n}\n\n.auth-form {\n  margin-bottom: 1.5rem;\n}\n\n.form-group {\n  margin-bottom: 1.75rem;\n}\n\n.form-group label {\n  display: block;\n  color: #4a5568;\n  font-weight: 600;\n  margin-bottom: 0.75rem;\n  font-size: 0.95rem;\n  letter-spacing: 0.3px;\n}\n\n.form-group input {\n  width: 100%;\n  padding: 1.1rem 1.25rem;\n  border: 2px solid #e1e5e9;\n  border-radius: 12px;\n  font-size: 1rem;\n  line-height: 1.5;\n  background: rgba(255, 255, 255, 0.8);\n  transition: all 0.3s ease;\n  backdrop-filter: blur(10px);\n  min-height: 48px;\n  box-sizing: border-box;\n}\n\n.form-group input::placeholder {\n  color: #a0aec0;\n  font-weight: 400;\n}\n\n.form-group input:focus {\n  outline: none;\n  border-color: #667eea;\n  background: rgba(255, 255, 255, 1);\n  box-shadow: 0 0 0 4px rgba(102, 126, 234, 0.15),\n    0 4px 12px rgba(102, 126, 234, 0.1);\n  transform: translateY(-2px);\n}\n\n.form-group input:disabled {\n  background: #f5f5f5;\n  cursor: not-allowed;\n}\n\n.server-info {\n  display: block;\n  margin-top: 0.75rem;\n  color: #10b981;\n  font-size: 0.85rem;\n  font-weight: 600;\n  background: rgba(16, 185, 129, 0.1);\n  padding: 0.5rem 0.75rem;\n  border-radius: 8px;\n  border-left: 3px solid #10b981;\n}\n\n.btn-block {\n  width: 100%;\n  padding: 1rem 2rem;\n  font-size: 1.1rem;\n  font-weight: 600;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);\n  color: white;\n  border: none;\n  border-radius: 12px;\n  cursor: pointer;\n  transition: all 0.3s ease;\n  box-shadow: 0 4px 15px rgba(102, 126, 234, 0.3);\n  letter-spacing: 0.5px;\n  text-transform: uppercase;\n  font-size: 0.95rem;\n}\n\n.btn-block:hover:not(:disabled) {\n  transform: translateY(-2px);\n  box-shadow: 0 8px 25px rgba(102, 126, 234, 0.4);\n  background: linear-gradient(135deg, #5a6fd8 0%, #6a4190 100%);\n}\n\n.btn-block:active:not(:disabled) {\n  transform: translateY(0px);\n  box-shadow: 0 4px 15px rgba(102, 126, 234, 0.3);\n}\n\n.btn-block:disabled {\n  background: linear-gradient(135deg, #9ca3af 0%, #9ca3af 100%);\n  cursor: not-allowed;\n  opacity: 0.7;\n  transform: none;\n  box-shadow: 0 2px 8px rgba(156, 163, 175, 0.2);\n}\n\n/* 아이디 저장 체크박스 스타일 */\n.remember-me-group {\n  margin-bottom: 1.5rem;\n}\n\n.remember-me-label {\n  display: flex;\n  align-items: center;\n  cursor: pointer;\n  font-size: 0.95rem;\n  color: #4a5568;\n  font-weight: 500;\n  margin-bottom: 0;\n}\n\n.remember-me-checkbox {\n  display: none;\n}\n\n.checkmark {\n  width: 20px;\n  height: 20px;\n  border: 2px solid #e1e5e9;\n  border-radius: 6px;\n  margin-right: 0.75rem;\n  position: relative;\n  transition: all 0.3s ease;\n  background: rgba(255, 255, 255, 0.8);\n  backdrop-filter: blur(10px);\n}\n\n.remember-me-checkbox:checked + .checkmark {\n  background: linear-gradient(135deg, #667eea, #764ba2);\n  border-color: #667eea;\n  box-shadow: 0 2px 8px rgba(102, 126, 234, 0.3);\n}\n\n.remember-me-checkbox:checked + .checkmark::after {\n  content: \"\";\n  position: absolute;\n  left: 6px;\n  top: 2px;\n  width: 6px;\n  height: 10px;\n  border: solid white;\n  border-width: 0 2px 2px 0;\n  transform: rotate(45deg);\n}\n\n.remember-me-label:hover .checkmark {\n  border-color: #667eea;\n  box-shadow: 0 0 0 2px rgba(102, 126, 234, 0.1);\n}\n\n.remember-me-checkbox:disabled + .checkmark {\n  opacity: 0.6;\n  cursor: not-allowed;\n}\n\n.auth-footer {\n  text-align: center;\n  color: #666;\n  padding-top: 1rem;\n  border-top: 1px solid #eee;\n}\n\n.auth-footer a {\n  color: #667eea;\n  text-decoration: none;\n  font-weight: 500;\n}\n\n.auth-footer a:hover {\n  text-decoration: underline;\n}\n\n.btn-secondary {\n  background: #6c757d;\n  color: white;\n  border: none;\n  padding: 0.75rem 1.5rem;\n  border-radius: 6px;\n  font-size: 1rem;\n  font-weight: 500;\n  cursor: pointer;\n  transition: all 0.2s;\n}\n\n.btn-secondary:hover {\n  background: #5a6268;\n  transform: translateY(-1px);\n}\n\n.demo-info {\n  margin-top: 2rem;\n  padding: 1rem;\n  background: #f8f9fa;\n  border-radius: 6px;\n  border-left: 4px solid #667eea;\n}\n\n.demo-title {\n  font-weight: bold;\n  color: #333;\n  margin-bottom: 0.5rem;\n}\n\n.demo-info p {\n  margin: 0.25rem 0;\n  color: #666;\n  font-size: 0.9rem;\n}\n\n/* 반응형 디자인 */\n@media (max-width: 768px) {\n  .auth-container {\n    padding: 1rem;\n  }\n\n  .auth-card {\n    padding: 2rem 1.5rem;\n    margin: 1rem;\n  }\n\n  .auth-card h1 {\n    font-size: 1.8rem;\n  }\n\n  .auth-subtitle {\n    font-size: 1rem;\n  }\n\n  .form-group input {\n    padding: 1rem 1rem;\n    min-height: 44px;\n  }\n\n  .btn-block {\n    padding: 0.875rem 1.5rem;\n  }\n\n  .logo-image {\n    height: 56px;\n  }\n}\n\n@media (max-width: 480px) {\n  .auth-card {\n    padding: 1.5rem 1rem;\n  }\n\n  .auth-card h1 {\n    font-size: 1.6rem;\n  }\n\n  .logo-image {\n    height: 48px;\n  }\n}\n\n/* 터치 디바이스를 위한 추가 스타일 */\n@media (hover: none) {\n  .auth-card:hover {\n    transform: none;\n  }\n\n  .btn-block:hover:not(:disabled) {\n    transform: none;\n  }\n\n  .form-group input:focus {\n    transform: none;\n  }\n}\n\n/* 다크모드 스타일 */\n.dark-theme .auth-container,\n[data-theme=\"dark\"] .auth-container {\n  background: linear-gradient(135deg, #2d3748 0%, #1a202c 100%);\n}\n\n.dark-theme .auth-card,\n[data-theme=\"dark\"] .auth-card {\n  background: rgba(26, 32, 44, 0.95);\n  border: 1px solid rgba(74, 85, 104, 0.3);\n  box-shadow: 0 25px 50px rgba(0, 0, 0, 0.5), 0 8px 16px rgba(0, 0, 0, 0.3),\n    inset 0 1px 0 rgba(74, 85, 104, 0.3);\n}\n\n.dark-theme .auth-card:hover,\n[data-theme=\"dark\"] .auth-card:hover {\n  box-shadow: 0 35px 70px rgba(0, 0, 0, 0.6), 0 15px 30px rgba(0, 0, 0, 0.4),\n    inset 0 1px 0 rgba(74, 85, 104, 0.3);\n}\n\n.dark-theme .auth-card h1,\n[data-theme=\"dark\"] .auth-card h1 {\n  background: linear-gradient(135deg, #9f7aea, #805ad5);\n  -webkit-background-clip: text;\n  -webkit-text-fill-color: transparent;\n  background-clip: text;\n}\n\n.dark-theme .auth-subtitle,\n[data-theme=\"dark\"] .auth-subtitle {\n  color: #a0aec0;\n}\n\n.dark-theme .form-group label,\n[data-theme=\"dark\"] .form-group label {\n  color: #e2e8f0;\n}\n\n.dark-theme .auth-container .form-group input[type=\"text\"],\n.dark-theme .auth-container .form-group input[type=\"password\"],\n[data-theme=\"dark\"] .auth-container .form-group input[type=\"text\"],\n[data-theme=\"dark\"] .auth-container .form-group input[type=\"password\"] {\n  background: rgba(45, 55, 72, 0.8) !important;\n  border: 2px solid #4a5568 !important;\n  color: #e2e8f0 !important;\n}\n\n.dark-theme .form-group input::placeholder,\n[data-theme=\"dark\"] .form-group input::placeholder {\n  color: #718096;\n}\n\n.dark-theme .auth-container .form-group input:focus,\n[data-theme=\"dark\"] .auth-container .form-group input:focus {\n  border-color: #9f7aea !important;\n  background: rgba(45, 55, 72, 1) !important;\n  box-shadow: 0 0 0 4px rgba(159, 122, 234, 0.15),\n    0 4px 12px rgba(159, 122, 234, 0.1) !important;\n}\n\n.dark-theme .form-group input:disabled,\n[data-theme=\"dark\"] .form-group input:disabled {\n  background: #2d3748;\n  color: #718096;\n}\n\n.dark-theme .server-info,\n[data-theme=\"dark\"] .server-info {\n  color: #48bb78;\n  background: rgba(72, 187, 120, 0.1);\n  border-left-color: #48bb78;\n}\n\n.dark-theme .btn-block,\n[data-theme=\"dark\"] .btn-block {\n  background: linear-gradient(135deg, #9f7aea 0%, #805ad5 100%);\n  box-shadow: 0 4px 15px rgba(159, 122, 234, 0.3);\n}\n\n.dark-theme .btn-block:hover:not(:disabled),\n[data-theme=\"dark\"] .btn-block:hover:not(:disabled) {\n  background: linear-gradient(135deg, #805ad5 0%, #6b46c1 100%);\n  box-shadow: 0 8px 25px rgba(159, 122, 234, 0.4);\n}\n\n.dark-theme .btn-block:disabled,\n[data-theme=\"dark\"] .btn-block:disabled {\n  background: linear-gradient(135deg, #4a5568 0%, #4a5568 100%);\n  box-shadow: 0 2px 8px rgba(74, 85, 104, 0.2);\n}\n\n.dark-theme .error-message,\n[data-theme=\"dark\"] .error-message {\n  background: linear-gradient(135deg, #fc8181, #f56565);\n}\n\n.dark-theme .remember-me-label,\n[data-theme=\"dark\"] .remember-me-label {\n  color: #e2e8f0;\n}\n\n.dark-theme .checkmark,\n[data-theme=\"dark\"] .checkmark {\n  background: rgba(45, 55, 72, 0.8);\n  border-color: #4a5568;\n}\n\n.dark-theme .remember-me-checkbox:checked + .checkmark,\n[data-theme=\"dark\"] .remember-me-checkbox:checked + .checkmark {\n  background: linear-gradient(135deg, #9f7aea, #805ad5);\n  border-color: #9f7aea;\n  box-shadow: 0 2px 8px rgba(159, 122, 234, 0.3);\n}\n\n.dark-theme .remember-me-label:hover .checkmark,\n[data-theme=\"dark\"] .remember-me-label:hover .checkmark {\n  border-color: #9f7aea;\n  box-shadow: 0 0 0 2px rgba(159, 122, 234, 0.1);\n}\n\n.dark-theme .logo-image,\n[data-theme=\"dark\"] .logo-image {\n  filter: drop-shadow(0 4px 8px rgba(0, 0, 0, 0.3)) brightness(1.2);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
